<script>
  import http from '@/service/http'
  import findIndex from 'lodash/findIndex'
  import {mapState, mapGetters} from 'vuex'
  import moment from 'moment'

  moment.locale('pt-br')
  export default {
    name: 'Os',
    data () {
      return {
        list: [],
        usuarios: [{}],
        usuario_id: '',
        busca: '',
        pagination: {
          current_page: 1,
          last_page: 1
        },
        status: {
          geral: '',
          novo: '',
          andamento: '',
          cancelada: '',
          finalizada: ''
        },
        show: {
          filtro: false
        },
        filtro: {
          status: '',
          revisao: ''
        },
        statusList: [],
        statusActive: '',
        tipo: 1
      }
    },
    mounted () {
      const {status} = this.$route.params
      const {revisao} = this.$route.params
      if (status !== undefined) {
        this.filtro.status = status
        this.filtro.revisao = revisao
        this.show.filtro = true
        this.tipo = revisao
        this.statusActive = status
        this.filtrar()
      } else {
        this.filtro.status = ''
        this.filtro.revisao = 1
        this.paginate()
      }
    },
    watch: {
      usuario_id () {
        this.buscar()
      }
    },
    methods: {
      async paginate (page) {
        if (page) {
          this.pagination.current_page = page
        }
        const {data} = await http.get(`/os?page=${this.pagination.current_page}&busca=${this.busca}&status=${this.filtro.status}&revisao=${this.filtro.revisao}&usuarios=${this.usuario_id}`)
        if (data != null) {
          this.list = data.rows.data
          this.usuarios = data.usuarios
          this.statusList = data.statusList
          this.pagination.current_page = data.rows.current_page
          this.pagination.last_page = data.rows.last_page
          this.filtro = data.filtro
          this.status = data.status
          setTimeout(function () {
            window.Materialize.updateTextFields()
          }, 0)
        }
      },
      async buscar () {
        this.show.filtro = false
        const {data} = await http.get(`/os?&busca=${this.busca}&usuarios=${this.usuario_id}`)
        if (data != null) {
          this.list = data.rows.data
          this.usuarios = data.usuarios
          this.statusList = data.statusList
          this.pagination.current_page = data.rows.current_page
          this.pagination.last_page = data.rows.last_page
          this.filtro = data.filtro
          this.status = data.status
          setTimeout(function () {
            window.Materialize.updateTextFields()
          }, 0)
        }
      },
      async filtrar () {
        this.busca = ''
        const {data} = await http.get(`/os?&status=${this.filtro.status}&revisao=${this.filtro.revisao}`)
        if (data != null) {
          this.statusList = data.statusList
          this.list = data.rows.data
          this.filtro = data.filtro
          this.pagination.current_page = data.rows.current_page
          this.pagination.last_page = data.rows.last_page
          this.status = data.status
          setTimeout(function () {
            window.Materialize.updateTextFields()
          }, 0)
        }
      },
      checkListTotal () {
        if (this.list.length === 0) {
          this.pagination.current_page = 1
          this.busca = ''
          this.usuario_id = ''
          this.paginate()
        }
      },
      updateList (obj) {
        const {os} = obj
        os.forEach(async (item) => {
          const index = await findIndex(this.list, {id: item.id})
          if (index > -1) {
            this.list[index] = {...item}
          } else {
            this.list.unshift(item)
          }
        })
        window.Materialize.toast('Registro salvo com sucesso!!', 4000)
      },
      destroy (os) {
        this.$swal({
          title: `Deseja remover ${os.id}?`,
          html: 'Esta operação é irreversível',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(async () => {
          const {data} = await http.delete(`/os/${os.id}`)
          if (data != null) {
            const index = await findIndex(this.list, {id: os.id})
            if (index > -1) {
              this.list.splice(index, 1)
              window.Materialize.toast('Registro removido com sucesso!!', 4000)
              this.checkListTotal()
            }
          }
        })
      },
      formatDate (date) {
        return moment(date).format('DD/MM HH:mm')
      },
      formatDateFrom (date) {
        return moment(date).fromNow()
      },
      changeStatus (status) {
        this.statusActive = status
        this.filtro.status = status
        this.filtrar()
      },
      changeRevisao () {
        this.filtro.revisao = this.tipo
        this.filtrar()
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['permissoes']),
      showBtNovo () {
        return this.$route.name === 'os.index'
      },
      showBtVoltar () {
        return this.$route.name === 'os.form'
      },
      hasItens () {
        return this.list.length > 0
      },
      api_url () {
        return process.env.API_URL
      },
      usuariosIds: {
        get () {
          return this.usuarios.filter(
            option => this.usuario_id.includes(option.id)
          )
        },
        set (newSelectedOptions) {
          this.usuario_id = newSelectedOptions.map(option => option.id)
        }
      }
    }
  }
</script>

<template>
  <div>

    <div class="content">

      <div class="row">
        <div class="col s12 m7">
          <h5>Ordens de Serviço</h5>
        </div>
        <div class="input-field col s9 m4">
          <form @submit.prevent="buscar" v-show="showBtNovo">
            <input id="busca" type="text" v-model="busca">
            <label for="busca">Buscar</label>
          </form>
        </div>
        <div class="col s3 m1 input-field right-align">
          <router-link :to="{ name: 'os.index' }" v-show="showBtVoltar"
                       class="btn-floating btn-large waves-effect waves-light red"><i class="material-icons">close</i>
          </router-link>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <router-view @update-os-list="updateList"></router-view>
        </div>
      </div>

      <div class="row" v-show="showBtNovo">
        <div class="col s12 m2">
          <label for="tipo">Tipo</label>
          <select name="tipo" id="tipo" :class="{invalid: errors.has('tipo')}" v-model.number="tipo"
                  @change="changeRevisao()">
            <option value="1">Todas</option>
            <option value="2">Com revisão</option>
            <option value="3">Sem revisão</option>
          </select>
          <small class="red-text">{{ errors.first('tipo') }}</small>
        </div>
        <div class="col s12 m10">
        <label for="tipo">Responsável Técnico</label>
            <input type="hidden" name="usuarios" v-model="usuario_id">
            <multiselect multiple placeholder="Todos os Técnicos" :closeOnSelect="false" v-model="usuariosIds" label="nome_completo" track-by="id" :options="usuarios"></multiselect>
          </div>
      </div>

      <div class="row" v-show="showBtNovo">
        <div class="col s12 m2">
          <div class="card pointer blue-grey darken-1" @click="changeStatus('')">
            <div class="card-content white-text">
              <span class="card-title">
                Geral <i v-show="statusActive === ''" class="material-icons">check_circle</i>
              </span>
              <p>{{ status[0] }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer" @click="changeStatus(1)">
            <div class="card-content white-text yellow accent-4">
              <span class="card-title">Novo <i v-show="statusActive === 1"
                                               class="material-icons">check_circle</i></span>
              <p>{{ status[1] }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer amber darken-4" @click="changeStatus(2)">
            <div class="card-content white-text">
              <span class="card-title">Andamento <i v-show="statusActive === 2" class="material-icons">check_circle</i></span>
              <p>{{ status[2] }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer amber accent-4" @click="changeStatus(3)">
            <div class="card-content white-text green accent-4">
              <span class="card-title">Finalizada <i v-show="statusActive === 3" class="material-icons">check_circle</i></span>
              <p>{{ status[3] }}</p>
            </div>
          </div>
        </div>

        <div class="col s12 m2">
          <div class="card pointer deep-orange accent-4" @click="changeStatus(4)">
            <div class="card-content white-text">
              <span class="card-title">Cancelada <i v-show="statusActive === 4" class="material-icons">check_circle</i></span>
              <p>{{ status[4] }}</p>
            </div>
          </div>
        </div>
      </div>

      <!--      <form @submit.prevent="filtrar">-->

      <!--        <div class="row" v-show="show.filtro">-->

      <!--          <div class="col s12 m4">-->
      <!--            <label for="filtro_status">Status</label>-->
      <!--            <select name="status" id="filtro_status" v-model="filtro.status">-->
      <!--              <option v-for="status in statusList" :value="status.id">{{ status.id ? status.status : 'Todos' }}</option>-->
      <!--            </select>-->
      <!--          </div>-->

      <!--          <div class="input-field col s12 m4">-->
      <!--            <label></label>-->
      <!--            <button style="margin-top: 10px;" class="waves-effect waves-light btn"><i class="material-icons left">filter_list</i> Filtrar</button>-->
      <!--          </div>-->

      <!--        </div>-->

      <!--      </form>-->

      <div class="center-align" v-show="showBtNovo && !hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="showBtNovo && hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
            <tr>
              <th>#</th>
              <th>#Orç</th>
              <th>Data</th>
              <th>Cliente</th>
              <th>Resp. Técnico</th>
              <th>Início</th>
              <th>Previsão Término</th>
              <th>Status</th>
              <th class="right-align">Ações</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="os in list" :class="{ 'green lighten-2': os.status_id === 3, 'red lighten-2': os.status_id === 4, 'amber lighten-1 black-text': os.status_id === 2, 'white': os.status_id === 1 }">
              <td>
                <router-link :to="{ name: 'os.form', params: { id: os.id } }"
                             v-if="permissoes.indexOf('os.editar') > -1">{{ os.id }}
                </router-link>
                <span v-else>{{ os.id }}</span>
              </td>
              <td>
                <router-link :to="{ name: 'orcamentos.form', params: { id: os.orcamento_id } }"
                             v-if="permissoes.indexOf('orcamento.editar') > -1">{{ os.orcamento_id }}
                </router-link>
                <span v-else>{{ os.orcamento_id }}</span>
              </td>
              <td>
                {{ formatDate(os.created_at) }}
                <small><br/>{{ formatDateFrom(os.created_at) }}</small>
              </td>
              <td>{{ (os.cliente) ? os.cliente.cliente : '-' }}{{ os.apartamento ? ` - ${os.apartamento}` : ''}}<br/>
                <small>{{ (os.orcamento) ? os.orcamento.responsavel : '-' }}</small>
                <br/>
                <small>{{ (os.orcamento) ? os.orcamento.localizacao_mapa : '-' }}</small>
                <small v-if="os.cliente && os.cliente.estrela > 0"><br/><i v-for="n in os.cliente.estrela" :key="n"
                                                                           class="material-icons"
                                                                           style="color: #ffea00; font-size: 1.5em; text-shadow: 0 0 3px #000;">star</i>
                </small>
              </td>
              <td>{{ (os.responsavel) ? os.responsavel.nome_completo : '-' }}</td>
              <td>{{ (os.inicio) ? os.inicio : '-' }}</td>
              <td>{{ (os.termino) ? os.termino : '-' }}</td>
              <td>
                {{ (os.status) ? os.status.status : '-' }}<br/><span class="" v-if="os.financeiro.length === 0">pendente financeiro</span>
              </td>
              <td class="right-align">
                <a :href="`${api_url}/os/${os.id}/pdf`" class="material-icons green-text" target="_blank"><i
                  class="material-icons">file_download</i></a>
                <router-link :to="{ name: 'os.form', params: { id: os.id } }"
                             v-show="permissoes.indexOf('os.editar') > -1"><i class="material-icons blue-text">edit</i>
                </router-link>
                <a href="#" @click.prevent="destroy(os)" v-show="permissoes.indexOf('os.excluir') > -1">
                  <i class="material-icons red-text">delete_forever</i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-show="showBtNovo && hasItens">
        <div class="col s12 center-align">
          <paginate
            :page-count='pagination.last_page'
            :click-handler="paginate"
            :prev-text="'chevron_left'"
            :next-text="'chevron_right'"
            :container-class="'pagination'"
            :page-class="'waves-effect'"
            :prev-class="'material-icons'"
            :next-class="'material-icons'"
            :force-page='pagination.current_page-1'
          >
          </paginate>
        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/os/os/index.vue